$(function(){
    var $gameFrame = $('#gameFrame'),
        backgroundImage = getGameBackgroundImage($gameFrame);

    resizeGameFrame();
    checkIfImageExist(backgroundImage);
});